import Login from "@/pages/account/login";
import ForgotPassword from "@/pages/account/forgotPassword";
import RegisterAccount from "@/pages/account/registerAccount";
import User from "@/pages/account/user";
import Info from "@/pages/account/info";
import Certificate from "@/pages/account/certificate";
// import Verify from "@/components/verify";

const AccountRoutes = [
  {
    name: "Login",
    path: "login",
    component: <Login />,
  },
  // {
  //   name: "Verify",
  //   path: "verify",
  //   component: <Verify />,
  // },
  {
    name: "ForgotPassword",
    path: "forgot_password",
    component: <ForgotPassword />,
  },
  {
    name: "RegisterAccount",
    path: "register_account",
    component: <RegisterAccount />,
  },
  {
    name: "User",
    path: "user",
    component: <User />,
    children: [
      {
        name: "Info",
        path: "info",
        component: <Info />,
      },
      {
        name: "Certificate",
        path: "certificate",
        component: <Certificate />,
      },
    ],
  },
];

export default AccountRoutes;
